import { render } from "./UploadStaticFilesModal.vue?vue&type=template&id=1fbed132&scoped=true"
import script from "./UploadStaticFilesModal.vue?vue&type=script&lang=js"
export * from "./UploadStaticFilesModal.vue?vue&type=script&lang=js"

import "./UploadStaticFilesModal.vue?vue&type=style&index=0&id=1fbed132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbed132"]])

export default __exports__